// extracted by mini-css-extract-plugin
export default {"overlay":"spinner_overlay__9Z7Hd","spinner":"spinner_spinner__Mweo2"};